import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const ContainerItem = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 12px;
	width: inherit;
	font-weight: 500;
	color: ${tokens.color_gray_dark};

	span {
		height: auto;
		font-size: 14px;
	}
`;
